"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE_IS_NOT_OBJECT = void 0;
var TYPE_IS_NOT_OBJECT = 'TYPE_IS_NOT_OBJECT';
exports.TYPE_IS_NOT_OBJECT = TYPE_IS_NOT_OBJECT;